import { SCHEDULED_REPORTS_SERVICE_HOSTS } from './config';
import {
  getGetRequestInit,
  getPostRequestInit,
  deleteRequestInit,
  getProxyServicePath,
  retrieveTextData,
  retrieveData,
} from './common';
import { getReportFieldFromValue } from '../dashboard/reportFieldService';
import {
  addWeeks,
  addMonths,
  addQuarters,
  startOfWeek,
  startOfMonth,
  startOfQuarter,
  set,
} from 'date-fns';


export const createScheduledReport = async (reportData, token) => {
  const serviceEndpoint = getProxyServicePath(SCHEDULED_REPORTS_SERVICE_HOSTS);
  const url = `${serviceEndpoint}/v1/report/full`;

  const requestInit = getPostRequestInit(reportData, token);

  return await retrieveTextData(url, requestInit);
};

export const getAllReports = async (token) => {
  const serviceEndpoint = getProxyServicePath(SCHEDULED_REPORTS_SERVICE_HOSTS);
  const url = `${serviceEndpoint}/v1/reports`;

  const requestInit = getGetRequestInit(token);

  const data = await retrieveData(url, requestInit);

  return data;
};

export const getReport = async (id, token) => {
  const serviceEndpoint = getProxyServicePath(SCHEDULED_REPORTS_SERVICE_HOSTS);
  const url = `${serviceEndpoint}/v1/report/full/${id}`;

  const requestInit = getGetRequestInit(token);

  return await retrieveData(url, requestInit);
};

export const deleteReport = async (id, token) => {
  const serviceEndpoint = getProxyServicePath(SCHEDULED_REPORTS_SERVICE_HOSTS);
  const url = `${serviceEndpoint}/v1/report/full/${id}`;

  const requestInit = deleteRequestInit(token);

  return await retrieveData(url, requestInit);
};

export const setScheduledReport = async (id, reportData, token) => {
  const serviceEndpoint = getProxyServicePath(SCHEDULED_REPORTS_SERVICE_HOSTS);
  const url = `${serviceEndpoint}/v1/report/schedule/${id}`;

  const requestInit = getPostRequestInit(reportData, token);

  return await retrieveData(url, requestInit);
};

export const sendPreviewReport = async (reportData, token) => {
  const serviceEndpoint = getProxyServicePath(SCHEDULED_REPORTS_SERVICE_HOSTS);
  const url = `${serviceEndpoint}/v1/send-preview`;

  const requestInit = getPostRequestInit(reportData, token);

  return await retrieveData(url, requestInit);
};

export const getDimensionsTagsFromReport = (report, allReportFields = []) => {
  const dimensions = report?.filterJson?.dimensions;

  if (!dimensions) {
    return [];
  }

  return dimensions.map(dimension => {
    const dimensionData = getReportFieldFromValue(allReportFields, dimension);

    return dimensionData?.key;
  });
};

export const getMetricsTagsFromReport = (report, allReportFields = []) => {
  const metrics = report?.filterJson?.metrics;

  if (!metrics) {
    return [];
  }

  return metrics.map(metric => {
    const metricData = getReportFieldFromValue(allReportFields, metric);

    return metricData?.key;
  });
};

export const isReportScheduled = (reportData) => {
  const schedule = reportData.schedule;

  return schedule && schedule !== 'not scheduled';
};

export const getFirstDayOfDelivery = (emailFrequency, startDateSelected) => {
  let nextSendDate;

  if (emailFrequency === 'weekly') {
    if (
      startOfWeek(startDateSelected, { weekStartsOn: 1 }).getDate() === startDateSelected.getDate()
    ) {
      nextSendDate = startDateSelected;
    } else {
      nextSendDate = startOfWeek(addWeeks(startDateSelected, 1), { weekStartsOn: 1 });
    }
  } else if (emailFrequency === 'biweekly') {
    const startDate = startDateSelected.getDate();

    nextSendDate = startDate > 14
      ? startOfMonth(addMonths(startDateSelected, 1))
      : set(startDateSelected, { date: 14 });
  } else if (emailFrequency === 'monthly') {
    if (startOfMonth(startDateSelected).getDate() === startDateSelected.getDate()) {
      nextSendDate = startDateSelected;
    } else {
      nextSendDate = startOfMonth(addMonths(startDateSelected, 1));
    }
  } else if (emailFrequency === 'quarterly') {
    const testStartOfQuarter = startOfQuarter(startDateSelected);

    if (
      testStartOfQuarter.getMonth() === startDateSelected.getMonth()
      && testStartOfQuarter.getDate() === startDateSelected.getDate()
    ) {
      nextSendDate = startDateSelected;
    } else {
      nextSendDate = startOfQuarter(addQuarters(startDateSelected, 1));
    }
  } else {
    nextSendDate = startDateSelected;
  }

  return nextSendDate;
};
